<!-- Header fixo no topo -->
<header class="fixed top-0 left-0 right-0 z-30 h-16">
  <app-topbar />
</header>

<!-- Sidebar -->
<aside
  class="fixed left-0 z-20 h-full bg-white border-r border-gray-200 transition-all duration-300 ease-in-out flex flex-col shadow-sm"
  [ngClass]="{
    'w-60': !isMenuCollapsed(),
    'w-16': isMenuCollapsed(),
  }"
  [style.top.px]="64"
>
  <!-- Header do Menu Lateral -->
  <div
    class="flex items-center border-b border-gray-100 transition-all duration-300"
    [ngClass]="{
      'justify-center px-2 py-4': isMenuCollapsed(),
      'justify-between px-4 py-4': !isMenuCollapsed(),
    }"
  >
    <!-- Logo e Nome -->
    <div
      class="flex items-center gap-3 transition-all duration-300 overflow-hidden"
      [ngClass]="{
        'opacity-0 w-0': isMenuCollapsed(),
        'opacity-100 w-auto': !isMenuCollapsed(),
      }"
    >
      <img
        [src]="'brand/logo.png'"
        alt="Logo AgiSales"
        class="h-8 w-auto flex-shrink-0"
      />
    </div>

    <button
      type="button"
      class="flex-shrink-0 p-2 text-blue-600 transition-colors rounded-lg hover:bg-blue-50 active:bg-blue-100"
      (click)="toggleMenuCollapse()"
      [attr.aria-label]="isMenuCollapsed() ? 'Expandir menu' : 'Recolher menu'"
      [attr.aria-expanded]="!isMenuCollapsed()"
    >
      <span
        class="text-2xl mt-2 material-icons transition-transform duration-300"
      >
        {{ isMenuCollapsed() ? 'chevron_right' : 'chevron_left' }}
      </span>
    </button>
  </div>

  <!-- Menu Items -->
  <nav class="flex-1 overflow-y-auto mt-2 scrollbar-thin">
    <app-menu
      [items]="(menuItems$ | async) ?? []"
      [isCollapsed]="isMenuCollapsed()"
    />
  </nav>
</aside>

<!-- Main Content Area -->
<main
  class="relative flex flex-col flex-1 w-full min-w-0 overflow-x-hidden transition-all duration-300 ease-in-out"
  [ngClass]="{
    'ml-60': !isMenuCollapsed(),
    'ml-16': isMenuCollapsed(),
  }"
  [style.margin-top.px]="64"
>
  <!-- Content Area - Responsivo -->
  <div
    class="flex-1 w-full min-w-0 min-h-full px-0 py-0 overflow-x-hidden bg-gray-50"
  >
    <router-outlet />
  </div>
</main>

<app-backdrop [visible]="(loading$ | async) ?? false">
  <app-spinner [loading]="true" />
</app-backdrop>
